<template>
  <div class="ueditor">
    <script :id="id" name="content" type="text/plain"></script>
    <!-- dialog -->
    <el-dialog :title="uploader[uploaderType].title" :visible.sync="dialogVisible" :close-on-click-modal="false" class="editor-dialog" :before-close="beforeClose">
      <!-- 图片 -->
      <template v-if="uploaderType === 'image'">
        <el-upload action="//upload.qiniup.com/" list-type="picture-card" multiple accept="image/*" :before-upload="beforeUpload" :on-success="imageUploadSuccess" :data="uploadParam" ref="imageUploader">
          <i class="el-icon-plus"></i>
        </el-upload>
      </template>
      <!-- 视频 -->
      <template v-if="uploaderType === 'video'">
        <div class="editor-dialog">
          <div class="pic"><img :src="video.imageUrl" v-show="video.imageUrl"></div>
          <div class="content">
            <dl>
              <dt>上传视频</dt>
              <dd>
                <el-upload action="//upload.qiniup.com/" accept="video/*" :on-change="fileUploadChange" :on-remove="videoRemove" :before-upload="beforeUpload" :on-success="videoUploadSuccess" :data="uploadParam" :file-list="fileList" ref="fileUploader">
                  <el-button size="small">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">视频不能超过20M，视频时长不少于1秒，不多于10小时，目前只支持MP4格式的视频文件</div>
                </el-upload>
              </dd>
            </dl>
            <dl>
              <dt>上传封面</dt>
              <dd>
                <el-upload action="//upload.qiniup.com/" accept="image/*" :on-change="imageUploadChange" :on-remove="videoImageRemove" :before-upload="beforeUpload" :on-success="videoImageUploadSuccess" :data="uploadParam" :file-list="imageList" ref="imageUploader">
                  <el-button size="small">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">若不上传，则默认视频首屏为封面图</div>
                </el-upload>
              </dd>
            </dl>
          </div>
        </div>
      </template>
      <!-- 音频 -->
      <template v-if="uploaderType === 'audio'">
        <div class="editor-dialog">
          <el-form :model="audio" :rules="audioRules" ref="audioForm" label-width="100px">
            <el-form-item label="标题" prop="title">
              <el-input v-model="audio.title" placeholder="请输入音频文件的标题（必填）"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="subject">
              <el-input v-model="audio.subject" placeholder="请输入音频文件的简介（选填）"></el-input>
            </el-form-item>
            <el-form-item label="语音内容">
              <el-upload action="//upload.qiniup.com/" accept="audio/*" :on-change="fileUploadChange" :on-remove="audioRemove" :before-upload="beforeUpload" :on-success="audioUploadSuccess" :data="uploadParam" :file-list="imageList" ref="imageUploader">
                <el-button size="small">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">格式支持MP3，文件大小不超过30M，语音时长不超过30分钟</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="uploader[uploaderType].onOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* ueditor */
// import '../../../../public/assets/js/ueditor/themes/default/css/ueditor.css'
// import '../../../../public/assets/js/ueditor/ueditor.config'
// import '../../../../public/assets/js/ueditor/ueditor.all'
// import '../../../../public/assets/js/ueditor/lang/zh-cn/zh-cn'
/* 七牛 */
import { getToken, fetchImage } from '@/api/common'
import md5 from 'md5'
import { Base64 } from 'js-base64'
// 默认配置
let defaultConfig = {
  toolbars: [
    [
      'undo',
      'redo',
      '|',
      'fontsize',
      '|',
      'blockquote',
      'horizontal',
      '|',
      'removeformat',
      'formatmatch',
      '|',
      'link',
      'unlink'
    ],
    [
      'bold',
      'italic',
      'underline',
      'forecolor',
      'backcolor',
      '|',
      'justifyleft',
      'justifycenter',
      'justifyright',
      'justifyjustify',
      '|',
      'rowspacingtop',
      'rowspacingbottom',
      'lineheight',
      '|',
      'insertorderedlist',
      'insertunorderedlist',
      '|',
      'imagenone',
      'imageleft',
      'imageright',
      'imagecenter',
      '|'
    ]
  ],
  initialFrameHeight: 500,
  elementPathEnabled: false, // 左下角元素路径
  wordCount: false,
  imageScaleEnabled: false, // 启用图片拉伸缩放
  imagePopup: false, // 图片操作的浮层开关，默认打开
  catchRemoteImageEnable: false // 设置远程图片是否抓取到本地保存
}
export default {
  name: 'ueditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      id: `ueditor_${+new Date()}`,
      editor: null,
      isReady: false,
      dialogVisible: false,
      uploadParam: { token: '', key: '' },
      fileList: [],
      imageList: [],
      images: [],
      video: {
        videoUrl: '',
        videoWidth: null,
        videoHeight: null,
        imageUrl: '',
        imageWidth: null,
        imageHeight: null
      },
      audio: { title: '', subject: '', audioUrl: '', duration: null },
      audioRules: {
        title: {
          required: true,
          message: '请输入音频文件的标题',
          trigger: 'blur'
        },
        subject: { max: 14, message: '长度在 14 个字符以内', trigger: 'blur' }
      },
      uploaderType: 'image',
      uploader: {
        image: { title: '上传图片', onOk: this.insertImage },
        video: { title: '上传视频', onOk: this.insertVideo },
        audio: { title: '上传音频', onOk: this.insertAudio }
      }
    }
  },
  methods: {
    upload(type) {
      this.uploaderType = type
      this.dialogVisible = true
    },
    // 上传前
    beforeUpload(file) {
      let key =
        'zaiart/admin/file/' +
        md5(file.name + new Date().getTime()) +
        file.name.substr(file.name.lastIndexOf('.'))
      return new Promise((resolve, reject) => {
        getToken()
          .then(response => {
            this.uploadParam.token = response.data
            this.uploadParam.key = key
            resolve(true)
          })
          .catch(err => {
            reject(new Error(err))
          })
      })
    },
    // 上传文件改变
    fileUploadChange(file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    // 上传图片改变
    imageUploadChange(file, fileList) {
      this.imageList = fileList.slice(-1)
    },
    // 获取图片信息
    getImageInfo(imageUrl) {
      return new Promise((resolve, reject) => {
        let image = new Image()
        image.src = imageUrl
        image.onload = () => {
          let imageInfo = {
            url: image.src,
            width: image.width,
            height: image.height
          }
          resolve(imageInfo)
        }
        image.onerror = err => {
          reject(err)
        }
      })
    },
    // 获取视频信息
    getVideoInfo(videoUrl) {
      // 获取视频宽高
      let videoInfo = new Promise((resolve, reject) => {
        let video = document.createElement('video')
        video.src = videoUrl
        video.addEventListener(
          'loadedmetadata',
          function() {
            resolve({
              width: this.videoWidth,
              height: this.videoHeight
            })
          },
          false
        )
      })
      // 获取视频封面
      let videoImage = new Promise((resolve, reject) => {
        fetchImage(`${videoUrl}?vframe/jpg/offset/1`).then(response => {
          resolve(response.data)
        })
      })
      return Promise.all([videoInfo, videoImage]).then(values => {
        return {
          videoUrl: videoUrl,
          videoWidth: values[0].width,
          videoHeight: values[0].height,
          imageUrl: values[1].url
        }
      })
    },
    // 获取音频信息
    getAudioInfo(audioUrl) {
      return new Promise((resolve, reject) => {
        let audio = document.createElement('audio')
        audio.src = audioUrl
        audio.addEventListener(
          'loadedmetadata',
          function() {
            // 获取音频时间
            resolve({
              audioUrl: audioUrl,
              duration: this.duration * 1000
            })
          },
          false
        )
      })
    },
    // 图片上传成功
    imageUploadSuccess(response, file, fileList) {
      let imageUrl = `https://img.zai-art.com/${response.key}`
      this.getImageInfo(imageUrl).then(response => {
        this.images.push(response)
      })
    },
    // 视频上传成功
    videoUploadSuccess(response, file, fileList) {
      let videoUrl = `https://img.zai-art.com/${response.key}`
      this.video.url = videoUrl
      this.getVideoInfo(videoUrl).then(response => {
        this.video = Object.assign({}, this.video, response)
      })
    },
    // 视频封面上传成功
    videoImageUploadSuccess(response, file, fileList) {
      let imageUrl = `https://img.zai-art.com/${response.key}`
      this.getImageInfo(imageUrl).then(response => {
        this.video.imageUrl = response.url
      })
    },
    // 音频上传成功
    audioUploadSuccess(response, file, fileList) {
      let audioUrl = `https://img.zai-art.com/${response.key}`
      this.getAudioInfo(audioUrl).then(response => {
        this.audio = Object.assign({}, this.audio, response)
      })
    },
    // 视频删除
    videoRemove(file, fileList) {
      this.video.videoUrl = ''
      this.video.videoWidth = null
      this.video.videoHeight = null
    },
    // 视频封面删除
    videoImageRemove(file, fileList) {
      this.video.imageUrl = ''
      this.video.imageWidth = null
      this.video.imageHeight = null
    },
    // 音频删除
    audioRemove(file, fileList) {
      this.audio.audioUrl = ''
      this.audio.duration = null
    },
    // 插入图片
    insertImage() {
      let imgHtml = ''
      if (this.images.length) {
        this.images.forEach(item => {
          imgHtml += `<p style="text-align:center;"><img src="${
            item.url
          }" data-width="${item.width}" data-height="${item.height}" /></p>`
        })
        this.editor.execCommand('insertHtml', imgHtml)
        this.beforeClose()
      } else {
        this.$message.warning('请上传图片')
      }
    },
    // 插入视频
    insertVideo() {
      if (!this.video.videoUrl) {
        this.$message.warning('请上传视频')
        return false
      } else if (!this.video.imageUrl) {
        this.$message.warning('请上传视频封面图')
        return false
      }
      let html = `<iframe class="myVideo" style="width:639px !important;height:${639 *
        258 /
        345}px;" data-width="${this.video.videoWidth}" data-height="${
        this.video.videoHeight
      }" frameborder="0" allowfullscreen scrolling="no" src="//www.zai-art.com/appwrapper/appPlayer/index.html?videoUrl=${encodeURIComponent(
        this.video.videoUrl
      )}&pic1=${encodeURIComponent(this.video.imageUrl)}&width=${
        this.video.videoWidth
      }&height=${this.video.videoHeight}"></iframe>`
      this.editor.execCommand('insertHtml', html)
      this.beforeClose()
    },
    // 插入音频
    insertAudio() {
      if (!this.audio.title) {
        this.$message.warning('请输入标题')
        return false
      } else if (!this.audio.subject) {
        this.$message.warning('请输入简介')
        return false
      } else if (!this.audio.audioUrl) {
        this.$message.warning('请上传语音内容')
        return false
      }
      let html = `<iframe class="myaudio" style="width:100% !important;height:70px;" frameborder="0" allowfullscreen scrolling="no" src="//www.zai-art.com/appwrapper/appAudio/index.html?audioUrl=${encodeURIComponent(
        this.audio.audioUrl
      )}&time=${encodeURIComponent(this.audio.duration)}&title=${Base64.encode(
        this.audio.title
      )}&global=${Base64.encode(this.audio.subject)}"></iframe>`
      this.editor.execCommand('insertHtml', html)
      this.beforeClose()
    },
    // dialog 关闭前
    beforeClose(done) {
      this.dialogVisible = false
      this.fileList.length = 0
      this.imageList.length = 0
      // 清空图片数据
      this.images.length = 0
      // 清空视频数据
      this.video = {}
      // 清空音频数据
      this.audio = {}

      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.clearFiles()
        this.$refs.fileUploader.abort()
      }

      if (this.$refs.imageUploader) {
        this.$refs.imageUploader.clearFiles()
        this.$refs.imageUploader.abort()
      }
      done && done()
    },
    // 关闭dialog
    closeDialog() {
      this.beforeClose()
    },
    // 粘贴自动上传图片
    pasteAutoUploadImage(url) {
      return fetchImage(url).then(response => {
        return this.getImageInfo(response.data.url).then(response => {
          return response
        })
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      let options = Object.assign({}, defaultConfig, this.config)
      this.editor = window.UE.getEditor(this.id, options)

      let editor = this.editor

      // 编辑器准备就绪
      editor.ready(
        function(e) {
          this.isReady = true
          editor.setContent(this.value)
          this.$emit('ready', editor)
        }.bind(this)
      )

      // 内容更改
      editor.addListener(
        'contentChange',
        function() {
          this.$emit('input', editor.getContent())
          this.$emit('change', editor.getContent())
        }.bind(this)
      )

      // 光标聚焦
      editor.addListener(
        'focus',
        function() {
          this.$emit('focus')
        }.bind(this)
      )

      // 编辑器内部选取发生修改
      editor.addListener(
        'selectionchange',
        function() {
          this.$emit('selectionchange')
        }.bind(this)
      )

      // 粘贴之后，图片自动上传
      editor.addListener(
        'afterExecCommand',
        function() {
          let imageList = editor.body.getElementsByTagName('img')
          for (let i = 0; i < imageList.length; i++) {
            let image = imageList[i]
            if (!/zai-art\.com/gi.test(image.src)) {
              this.pasteAutoUploadImage(image.src).then(response => {
                image.src = response.url
                image.setAttribute('_src', response.url)
                image.setAttribute('data-width', response.width)
                image.setAttribute('data-height', response.height)
                image.removeAttribute('data-src')
                this.$emit('input', editor.getContent())
              })
              image.src =
                'https://www.zai-art.com/appwrapper_dist/appDefaultImage/upload-loading.jpg'
            }
          }
        }.bind(this)
      )

      // 过滤图片，属性
      editor.addInputRule(
        function(root) {
          let imageList = root.getNodesByTagName('img')
          imageList.length &&
            imageList.forEach(node => {
              node.attrs.src = node.attrs['data-src'] || node.attrs.src
            })
          this.$emit('input', editor.getContent())
        }.bind(this)
      )
    })
  },
  destroyed() {
    try {
      this.editor && this.editor.destroy()
      window.onscroll = null
    } catch (e) {
      this.editor = null
    }
  }
}
</script>
<style>
.editor-dialog .el-dialog {
  min-width: 600px;
}
/* video */
.editor-dialog .pic {
  float: left;
  width: 152px;
  height: 152px;
  background: #e9e9e9 url('../../../assets/img/admin/dialog_video_cover.png')
    no-repeat center center;
}
.editor-dialog .pic img {
  width: 100%;
  height: 100%;
}
.editor-dialog .content {
  margin-left: 166px;
}
.editor-dialog .content dl {
  margin-bottom: 10px;
}
.editor-dialog .content dt {
  float: left;
  width: 70px;
}
.editor-dialog .content dd {
  margin-left: 70px;
}
.editor-dialog .el-upload__tip {
  margin-bottom: 10px;
  color: #999;
  line-height: 20px;
}
</style>
